import { MagnetIcon, PlugIcon, SettingsIcon, ShieldCheckIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Battery Technology Fundamentals',
    summary: 'Introduction, electrical principles, electrochemistry, cells/modules/packs, performance characteristics, specifications.',
    icon: WrenchIcon,
  },
  {
    number: '2',
    title: 'Battery Chemistries & Advanced Technologies',
    summary: 'Lead-acid, lithium-ion, LFP, NMC, LTO, sodium-ion, flow batteries, solid-state, emerging technologies.',
    icon: SettingsIcon,
  },
  {
    number: '3',
    title: 'Battery Management & Power Conversion Systems',
    summary: 'BMS, monitoring, sensors, state estimation, balancing, protection, thermal, PCS, EMS, communication.',
    icon: MagnetIcon,
  },
  {
    number: '4',
    title: 'Battery Energy Storage Systems (BESS)',
    summary: 'Components, architecture, residential/commercial/industrial/utility applications, operating strategies, efficiency.',
    icon: ZapIcon,
  },
  {
    number: '5',
    title: 'Renewable Energy Storage & Grid Integration',
    summary: 'Solar storage, wind storage, hybrid systems, distributed resources, grid connection, microgrids, grid services.',
    icon: PlugIcon,
  },
  {
    number: '6',
    title: 'Battery Safety, Reliability & Lifecycle Management',
    summary: 'Safety fundamentals, thermal runaway, degradation, reliability, maintenance, end-of-life, recycling, sustainability, standards.',
    icon: ShieldCheckIcon,
  },
];
